<template>
  <div class="dialog">
    <div class="header">
      <span class="title">{{ title }}</span>
      <van-icon class="close" @click="handleClose" name="cross"/>
    </div>
    <van-divider/>
    <div class="content">
      <slot/>
    </div>
    <van-divider/>
    <div class="footer">
      <van-button @click="handleClose" class="button">{{ $t('common.Close') }}</van-button>
    </div>
  </div>
</template>
<script>
  import { Button, Divider, Icon } from "vant";
  export default {
    name: "CommonDialog",
    props: {
      title: String
    },
    components: {
      "van-button": Button,
      "van-divider": Divider,
      "van-icon": Icon
    },
    methods: {
      handleClose () {
        this.$emit("close");
      }
    }
  };
</script>
<style lang="scss" scope>
  .dialog {
    width: 710px;
    position: relative;
    .header {
      height: 100px;
      .title {
        margin-left: 25px;
        font-weight: 600;
      }
      .close {
        position: absolute;
        top: 44px;
        right: 33px;
      }
    }
    .content {
      padding: 30px;
      text-align: left;
      max-height: 800px;
      overflow: auto;
    }
    .footer {
      position: relative;
      height: 100px;
      .button {
        position: absolute;
        right: 33px;
        bottom: 34px;
        height: 68px;
        background-color: #fff;
        border-radius: 8px;
        border: solid 2px #ccc;
        font-size: 28px;
        line-height: 40px;
        letter-spacing: 1px;
        color: #333;
      }
    }
  }
</style>